import { render, staticRenderFns } from "./HelpBtn.vue?vue&type=template&id=19721f89&scoped=true&"
import script from "./HelpBtn.vue?vue&type=script&lang=js&"
export * from "./HelpBtn.vue?vue&type=script&lang=js&"
import style0 from "./HelpBtn.vue?vue&type=style&index=0&id=19721f89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19721f89",
  null
  
)

export default component.exports